import React, {useState, useEffect, ChangeEvent, FormEvent, useMemo} from 'react';
import BackOfficeAPIClient from "../../clients/BackofficeAPIClient";
import {workflowsBDC} from "../../enums/WorkflowsBDC";

interface Params {
  gdpr_is_active: boolean;
  pvo2_flow_direction: string;
}

const GroupSettings: React.FC = () => {
  const [params, setParams] = useState<Params | null>(null);
  const [updated, setUpdated] = useState(false);
  const [fetchInProgress, setFetchInProgress] = useState(false);

  const backofficeApiClient = new BackOfficeAPIClient()

  useEffect(() => {
    fetchParams();
  }, []);

  const fetchParams = async () => {
    await backofficeApiClient.get<Params>("/group-settings")
        .then((response) => {
          setParams(response);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setFetchInProgress(true);

    await backofficeApiClient.put<any>("/group-settings", params)
        .then((response) => {
          if (!response.success) {
            setFetchInProgress(false);
            throw Error(response.statusText);
          }
          setUpdated(false);
          setParams(null);
          setFetchInProgress(false);
          fetchParams();
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const onChange = (event: React.ChangeEvent<any>) => {
    const { name, type, checked, value } = event.target;
    if (!params) return;
    setParams({
      ...params,
      [name]: type === 'checkbox' ? checked : value
    });
    setUpdated(true);
  };

  if (!params) {
    return null;
  }

  return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col-3"></div>
              <div className="col">
                <div className="form-check">
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row">
              <div className="col-3"></div>
              <div className="col">
              </div>
            </div>
          </div>
        </div>

        {updated ?
            <div className="row mb-2" style={{ marginTop: '15px' }}>
              <div className="col text-center">
                <button disabled={fetchInProgress} type="submit" className="btn btn-primary">
                  {fetchInProgress ?
                      <span><i className='fa fa-spinner fa-spin fa-fw'></i>&nbsp;</span>
                      : null}
                  Enregistrer
                </button>
              </div>
            </div>
            : null}
      </form>
  );
}

export default GroupSettings;
